module.exports = __webpack_public_path__ + "static/media/jwp_conn_logo_white.725e07c8.webp";